import styled from 'styled-components';
import { colors } from 'core/theme';

export const List = styled.ul`
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;

  &:empty {
    display: none;
  }

  @media print {
    border-bottom: 1px solid ${colors.hairline};
    margin-top: 0;
    margin-bottom: 1em;
    padding-bottom: 1em;
    counter-reset: breadcrumbs;
    flex-direction: column;

    & > li:before {
      counter-increment: breadcrumbs;
      content: counter(breadcrumbs) ". ";
      margin-right: 0.75em;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/elements/Breadcrumbs/styled.js